module.exports = __webpack_public_path__ + "img/delivery-truck.76efa7ee.svg";